import React from 'react';
import { useUpdate } from 'react-admin';
import IconButton from '@material-ui/core/IconButton';
import FlagIcon from '@material-ui/icons/Flag';
import FlagIconOutlined from '@material-ui/icons/FlagOutlined';
import Tooltip from '@material-ui/core/Tooltip';

const FlagToggle = ({ record, resource }) => {
  const { id, flagged_by } = record;
  const { username } = JSON.parse(localStorage.getItem('user'));

  // If the resource is already flagged (has a flagged_by), unflag it.
  // Else, flag it with the currently signed in user's email

  const [setFlaggedBy] = useUpdate(
    resource,
    id,
    { flagged_by: flagged_by ? null : username },
    record,
  );

  return (
    <IconButton
      onClick={() => {
        setFlaggedBy();
      }}
    >
      {flagged_by ? (
        <Tooltip title={`Flagged by ${flagged_by}`}>
          <FlagIcon />
        </Tooltip>
      ) : (
        <Tooltip title="Click here to flag this item">
          <FlagIconOutlined />
        </Tooltip>
      )}
    </IconButton>
  );
};

export default FlagToggle;
